<template>
    <section
        class="hero-section ptb-100 background-img"
        style="
            background: url('img/hero-bg-2.jpg') no-repeat center center / cover;
        "
    >
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-md-8 col-lg-7">
                    <div
                        class="page-header-content text-white text-center pt-sm-5 pt-md-5 pt-lg-0"
                    >
                        <h1 class="text-white mb-0">Blog Left Sidebar</h1>
                        <div class="custom-breadcrumb">
                            <ol
                                class="breadcrumb d-inline-block bg-transparent list-inline py-0"
                            >
                                <li class="list-inline-item breadcrumb-item">
                                    <a href="#">Home</a>
                                </li>
                                <li class="list-inline-item breadcrumb-item">
                                    <a href="#">Blog</a>
                                </li>
                                <li
                                    class="list-inline-item breadcrumb-item active"
                                >
                                    Blog Left Sidebar
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "BannerLeftSidebar",
};
</script>

<style>
</style>